<section>
    <div class="container">
        <div class="col-md-6 text-left left-padding-0">
            <button *ngIf="isTicketCreate && !orderInfo.tabForOrderPromotion" class="btn blue-button print-hide"
                (click)="createDisputeTicket()">+
                {{'customer-service.Ticket' |translate}}</button>
        </div>
        <div *ngIf="userInfo" class="right-align-block">
                <div class="text-right member-details-block word-break--overflow">
                        <div class="row">
                            <div class="col-md-12 text-right">
                                <span class="color-blue uppercase">
                                    {{'order.MEMBER DETAILS' |translate|translateKey}}</span>
                            </div>
                        </div>
                        <div *ngIf="userInfo.name">
                            <div class="bold header-font color-black">
                                <span>{{userInfo | displayNameFormat}}</span>
                            </div>
                            <div *ngIf="userInfo.displayName && userInfo.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                                <span>{{userInfo.displayName | titlecase}}</span>
                              </div>
                            <div class="font14">
                                <a *ngIf="userInfo?.distributorId"><i class="fa fa-copy" [copyToClipboard]="userInfo.distributorId"></i></a>
                                <span *ngIf="userInfo">
                                    <span *ngIf="!isDownlineMemeber" class="color-black">
                                    {{userInfo.distributorId|distributorIdFormat}}</span>
                                    <a *ngIf="isDownlineMemeber" class="color-blue" (click)="navigateToFboDetails(userInfo)">{{userInfo.distributorId|distributorIdFormat}}</a> |<span class="color-black">
                                        {{userInfo.level | uppercase}}</span></span>
                            </div>
                            <div class="font14" *ngIf="userInfo.emailForCommunication">
                                <span class="color-blue">{{userInfo.emailForCommunication}}</span>
                            </div>
                            <div class="font14" *ngIf="!userInfo.emailForCommunication">
                                <span class="color-blue">{{userInfo.email}}</span>
                            </div>
                            <div class="font14" *ngIf="userInfo.level !== memberTypes.GUEST && userInfo.privacyRequested">
                                {{'customer-service.Privacy Requested' |translate }}: <span [class.ERROR]="userInfo.privacyRequested === 'Yes'"> {{'user.'+userInfo.privacyRequested |translate }}</span>
                            </div>
                        </div>
                </div>
        </div>
        <div *ngIf="orderInformation">
            <div>
                <ul class="list-group orderInfo-list-group">
                    <li class="list-group-item clearfix">
                        <div class="col-xs-6 no-padding">
                            <span class="header-font">
                                {{'customer-service.Order' |translate}}
                            </span>
                        </div>
                        <div class="col-xs-6">
                            <div class="">
                                <span class="pull-right header-font" *ngIf="orderInformation.webOrderNumber"> {{orderInformation.webOrderNumber}}/{{orderInformation.orderNumber}}</span>
                                <span class="pull-right header-font" *ngIf="!orderInformation.webOrderNumber"> {{orderInformation.orderNumber}}</span>
                            </div>
                        </div>
                    </li>
                    <li class="list-group-item">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>
                                            {{'customer-service.Order Date' |translate}}
                                        </th>
                                        <th>
                                            {{'customer-service.Total' |translate}}
                                        </th>
                                        <th>
                                            {{'customer-service.CC' |translate}}
                                        </th>
                                        <th>
                                            {{'customer-service.Source' |translate}}
                                        </th>
                                        <th>
                                            {{'customer-service.Status' |translate}}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            {{isOrderLoaded ? orderInformation.orderDate: ' '}}
                                        </td>
                                        <td>
                                            {{orderInformation.total | currencyFormat:storeInfo}}
                                        </td>
                                        <td *ngIf="showCCSnapshot">
                                            {{orderInformation.totalCC| number:'1.3-3'}}
                                        </td>
                                         <td *ngIf="!showCCSnapshot">
                                            {{'customer-service.NA' |translate | translateKey}}
                                        </td>
                                        <td>
                                            {{orderInformation.source}}
                                        </td>
                                        <td>
                                            {{orderInformation.orderStatus ? orderInformation.orderStatus : 'customer-service.NA' |translate | translateKey}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="table-responsive mb-20">
                <table class="table table-striped custab">
                    <thead>
                        <tr>
                            <th class="pointer" tabindex="0" (keyup.enter)="sortOrderInformationByColumn('sku')" (click)="sortOrderInformationByColumn('sku')">
                                <strong>{{'customer-service.Item #' |translate}}&nbsp;
                                    <i class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'sku', 'fa-sort-asc': (sortColumn  == 'sku' && !isDesc), 'fa-sort-desc': (sortColumn  == 'sku' && isDesc) }">
                                    </i>
                                </strong>
                            </th>
                            <th class="pointer" tabindex="0" (keyup.enter)="sortOrderInformationByColumn('productDescription')" (click)="sortOrderInformationByColumn('productDescription')">
                                <strong>{{'customer-service.Product Description' |translate}}&nbsp;
                                    <i class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'productDescription', 'fa-sort-asc': (sortColumn  == 'productDescription' && !isDesc), 'fa-sort-desc': (sortColumn  == 'productDescription' && isDesc) }">
                                    </i>
                                </strong>
                            </th>
                            <th tabindex="0" (keyup.enter)="sortOrderInformationByColumn('unitPrice')" (click)="sortOrderInformationByColumn('unitPrice')"
                                class="text-right pointer">
                                <strong>{{'customer-service.Unit Price' |translate}}&nbsp;
                                    <i class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'unitPrice', 'fa-sort-asc': (sortColumn  == 'unitPrice' && !isDesc), 'fa-sort-desc': (sortColumn  == 'unitPrice' && isDesc) }">
                                    </i>
                                </strong>
                            </th>
                            <th tabindex="0" (keyup.enter)="sortOrderInformationByColumn('quantity')" (click)="sortOrderInformationByColumn('quantity')"
                                class="text-center pointer">
                                <strong>{{'customer-service.Quantity' |translate}}&nbsp;
                                    <i class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'quantity', 'fa-sort-asc': (sortColumn  == 'quantity' && !isDesc), 'fa-sort-desc': (sortColumn  == 'quantity' && isDesc) }">
                                    </i>
                                </strong>
                            </th>
                            <th tabindex="0" (keyup.enter)="sortOrderInformationByColumn('cc')" (click)="sortOrderInformationByColumn('cc')" class="text-center pointer">
                                <strong>{{'customer-service.Total CC' |translate}}&nbsp;
                                    <i class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'cc', 'fa-sort-asc': (sortColumn  == 'cc' && !isDesc), 'fa-sort-desc': (sortColumn  == 'cc' && isDesc) }">
                                    </i>
                                </strong>
                            </th>
                            <th tabindex="0" (keyup.enter)="sortOrderInformationByColumn('price')" (click)="sortOrderInformationByColumn('price')" class="text-right pointer">
                                <strong>{{'customer-service.Price' |translate}}&nbsp;
                                    <i class="font-12 fa fa-sort" [ngClass]="{'fa-sort': sortColumn != 'price', 'fa-sort-asc': (sortColumn  == 'price' && !isDesc), 'fa-sort-desc': (sortColumn  == 'price' && isDesc) }">
                                    </i>
                                </strong>
                            </th>

                        </tr>
                    </thead>
                    <tbody *ngIf="orderInformation.productInfo && orderInformation.productInfo.length > 0">
                        <tr *ngFor="let productInfo of orderInformation.productInfo">
                            <td>{{productInfo.sku}}</td>
                            <td class="">{{productInfo.productDescription | titleCase}} </td>
                            <td class="text-right">{{productInfo.unitPrice | currencyFormat:storeInfo}}</td>
                            <td class="text-center">{{productInfo.quantity}}</td>
                            <td class="text-center" *ngIf="showCCSnapshot">{{productInfo.cc | number:'1.3-3'}}</td>
                            <td class="text-center" *ngIf="!showCCSnapshot">{{'customer-service.NA' |translate | translateKey}}</td>
                            <td class="text-right">{{productInfo.price | currencyFormat:storeInfo}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="row-sameheight-block word-break--overflow page-break" style="margin-bottom:20px;">
                <div class="column-equal border-1" style="border: 1px solid #0f7bb6; padding:15px">
                    <div class="">
                        <div class="row">
                            <div class="col-md-12 text-right">
                                <ng-template #shipTo><span class="color-blue">{{'customer-service.SHIP TO' |translate}}</span></ng-template>
                                <span class="color-blue" *ngIf="orderInformation.shippingInfo && orderInformation.shippingInfo.shippingMethod && orderInformation.shippingInfo.shippingMethod === ShipMethodEnums.pickupOrder; else shipTo">{{'customer-service.PICK UP' |translate}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3 col-md-3">
                                <span>{{'customer-service.Name' |translate}}</span>
                            </div>
                            <div class="col-sm-9 col-md-9 text-right">
                                <ng-template #notAvailable><span>NA</span></ng-template>
                                <span *ngIf="orderInformation.shippingInfo && orderInformation.shippingInfo.shippingName;else notAvailable">{{orderInformation.shippingInfo.shippingName}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'customer-service.Address' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right">
                                <span>{{orderInformation.shippingInfo.address.addressFirstLine}}</span>
                            </div>
                            <div *ngIf="orderInformation.shippingInfo.address.addressSecondLine" class="col-sm-7 col-sm-offset-5 col-md-7 col-md-offset-5 text-right">
                                <span>{{orderInformation.shippingInfo.address.addressSecondLine}}</span>
                            </div>
                            <div *ngIf="orderInformation.shippingInfo.address.addressThirdLine" class="col-sm-7 col-sm-offset-5 col-md-7 col-md-offset-5 text-right">
                                <span>{{orderInformation.shippingInfo.address.addressThirdLine}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'customer-service.City' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right">
                                <span>{{orderInformation.shippingInfo.address.city}} </span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-5 col-md-5">
                                <span *ngIf="shippingAddressInfoConfig && shippingAddressInfoConfig.displayStateCode">{{'customer-service.State/Zipcode' |translate}}</span>
                                <span *ngIf="shippingAddressInfoConfig && !shippingAddressInfoConfig.displayStateCode">{{'customer-service.Zipcode' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right">
                                <span><span *ngIf="shippingAddressInfoConfig && shippingAddressInfoConfig.displayStateCode">{{orderInformation.shippingInfo.address.state}}</span> {{orderInformation.shippingInfo.address.zipCode}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'customer-service.Country' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right">
                                <span>{{orderInformation.shippingInfo.address.country |uppercase}}</span>
                            </div>
                        </div>
                        <div class="row">
                                <div class="col-sm-5 col-md-5">
                                    <label>{{'customer-service.Date Shipped' |translate | translateKey}}</label>
                                </div>
                                <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.shippingInfo.shippingDate">
                                     &nbsp; {{ orderInformation.shippingInfo.shippingDate|date:'dd-MMM-yy' }}
                                </div>
                                <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.shippingInfo.shippingDate">
                                        &nbsp; {{'customer-service.NA' |translate | translateKey}}
                                   </div>
                        </div>
                        <!-- <div class="row">
                            <div class="col-md-5">
                                <span>{{'customer-service.Shipped Weight' |translate | translateKey}}</span>
                            </div>
                            <div class="col-md-7 text-right">
                                <span *ngIf="orderInformation.shippingWeight > 0">{{orderInformation.shippingWeight}}</span>
                                <span *ngIf="orderInformation.shippingWeight === 0">{{'customer-service.NA' |translate | translateKey}}</span>
                            </div>
                        </div> -->
                        <div class="row">
                                <div class="col-sm-5 col-md-5">
                                    <span>{{'customer-service.Warehouse Name' |translate}}</span>
                                </div>
                                <div class="col-sm-7 col-md-7 text-right">
                                    <span>{{orderInformation.shippingInfo.warehouseName}}</span>
                                </div>
                        </div>
                        <div class="row">
                                <div class="col-sm-5 col-md-5">
                                    <span>{{'customer-service.Shipping Method' |translate}}</span>
                                </div>
                                <div class="col-sm-7 col-md-7 text-right">
                                    <span>{{orderInformation.shippingInfo.shippingMethod}}</span>
                                </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-5 col-md-5">
                                <span>Tracking Number</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="shipTrackingUrl">
                                <a href="{{shipTrackingUrl}}" target="_blank">{{orderInformation.orderNumber}}</a>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="!shipTrackingUrl&&trackingModel">
                              <ng-container *ngFor="let trackingUrl of trackingUrls ;let i=index">
                              <div >
                                <a href="{{trackingUrl}}" target="_blank">Parcel{{i+1}}</a>
                              </div>
                            </ng-container>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="!shipTrackingUrl&&!trackingModel">
                                <span>{{'customer-service.NA' |translate}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column-equal" style="margin-left: auto;">
                    <div class="table-responsive">
                        <table class="table table-striped table-bordered custab">
                            <thead>
                                <tr>
                                    <th>{{'customer-service.Order Summary' |translate}}</th>
                                    <th class="text-right">{{'customer-service.Amount' |translate}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{'customer-service.Sub Total' |translate}}</td>
                                    <td class="text-right">{{(orderInformation.subTotal? orderInformation.subTotal: 0)  | currencyFormat:storeInfo}}</td>
                                    <!-- <td class="text-right">{{orderInformation.subTotal?(orderInformation.subTotal | number:'1.2-2'):'-'}}{{storeInfo.currencyCode}}</td> -->
                                </tr>
                                <tr>
                                    <td>{{'customer-service.Shipping & Handling' |translate}}</td>
                                    <td class="text-right">{{(orderInformation.shipping? orderInformation.shipping : 0)  | currencyFormat:storeInfo}}</td>
                                </tr>
                                <!-- <tr *ngIf="orderInformation && orderInformation.countryCode && orderInformation.countryCode.toLowerCase() !== 'can'">
                                    <td>{{'customer-service.Taxes' |translate}}</td>
                                    <td class="text-right">{{(orderInformation.tax? orderInformation.tax : 0)  | currencyFormat:storeInfo}}</td>
                                </tr> -->
                                <!-- <tr *ngIf="orderInformation && orderInformation.countryCode && orderInformation.countryCode.toLowerCase() === 'can'">
                                    <td>{{'customer-service.GST Tax' |translate}}</td>
                                    <td class="text-right">{{(gstTax? gstTax : 0)  | currencyFormat:storeInfo}}</td>
                                </tr>
                                <tr *ngIf="orderInformation && orderInformation.countryCode && orderInformation.countryCode.toLowerCase() === 'can'">
                                    <td>{{'customer-service.PST Tax' |translate}}</td>
                                    <td class="text-right">{{(pstTax? pstTax : 0)  | currencyFormat:storeInfo}}</td>
                                </tr> -->
                                 <tr *ngIf="(orderInformation?.countryCode?.toLowerCase() !== IsoCodeThree?.GBR?.toLowerCase()) || !(orderInformation?.taxMetaData?.orderTaxCharges)">
                                    <td>{{'customer-service.Taxes' |translate}}</td>
                                    <td class="text-right">{{(orderInformation?.tax? orderInformation.tax : 0)  | currencyFormat:storeInfo}}</td>
                                </tr>
                                <ng-container *ngIf="orderInformation?.taxMetaData?.orderTaxCharges">
                                <tr *ngFor="let item of orderInformation?.taxMetaData?.orderTaxCharges | orderBy:'taxRate' | groupBy:'taxChargeType';let i=index;trackBy:trackByItem">
                                        <td>{{'customer-service.VAT' | translate | translateKey}} ({{item.value[0].taxChargeType}}) {{item.value[0].taxRate}}%</td>
                                        <td class="text-right">{{ getItemVolumeSum(item.value) | currencyFormat:storeInfo}}
                                        </td>
                                    </tr>
                                </ng-container>
                                <tr>
                                    <td>{{'customer-service.Fees' |translate}}</td>
                                    <td class="text-right">{{(orderInformation.importFess? orderInformation.importFess : 0)  | currencyFormat:storeInfo}}</td>
                                </tr>
                                <tr  class="bold">
                                    <td>{{'customer-service.Total' |translate}}</td>
                                    <td class="text-right">{{orderInformation.total | currencyFormat:storeInfo}}</td>
                                </tr>
                                <tr class="bold">
                                    <td>Total CC</td>
                                    <td class="text-right" *ngIf="showCCSnapshot">{{orderInformation.totalCC | number:'1.3-3'}}</td>
                                    <td class="text-right" *ngIf="!showCCSnapshot">{{'customer-service.NA' |translate | translateKey}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="row-sameheight-block word-break--overflow page-break" style="margin-bottom:20px;">
                <div class="column-equal border-1" style="border: 1px solid #0f7bb6; padding:15px">
                    <div class="row">
                        <div class="col-md-12 text-right">
                            <span class="color-blue">{{'customer-service.BILL TO' |translate}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 col-md-3">
                            <span>{{'customer-service.Name' |translate}}</span>
                        </div>
                        <div class="col-sm-9 col-md-9 text-right"  *ngIf="orderInformation.billingInfo && orderInformation.billingInfo.address">
                            <span *ngIf="!orderInformation.billingInfo.address.name">{{'customer-service.NA' |translate}}</span>
                            <span *ngIf="orderInformation.billingInfo.address.name"> {{orderInformation.billingInfo.address.name}}</span>
                        </div>
                        <div class="col-sm-9 col-md-9 text-right"  *ngIf="!orderInformation.billingInfo.address">
                            <span>  {{'customer-service.NA' |translate}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-5 col-md-5">
                            <span>{{'customer-service.Address' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.address">
                            <span *ngIf="orderInformation.billingInfo.address.addressFirstLine"> {{orderInformation.billingInfo.address.addressFirstLine }}</span>
                            <span *ngIf="!orderInformation.billingInfo.address.addressFirstLine"> {{'customer-service.NA' |translate}}</span>
                        </div>
                        <div *ngIf="orderInformation.billingInfo.address" class="col-sm-7 col-sm-offset-5 col-md-7 col-md-offset-5 text-right">
                            <span *ngIf="orderInformation.billingInfo.address.addressSecondLine">{{orderInformation.billingInfo.address.addressSecondLine}}</span>
                        </div>
                        <div *ngIf="orderInformation.billingInfo.address" class="col-sm-7 col-sm-offset-5 col-md-7 col-md-offset-5 text-right">
                            <span *ngIf="orderInformation.billingInfo.address.addressThirdLine">{{orderInformation.billingInfo.address.addressThirdLine}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right"  *ngIf="!orderInformation.billingInfo.address">
                            <span>  {{'customer-service.NA' |translate}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-5 col-md-5">
                            <span>{{'customer-service.City' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.address">
                            <span *ngIf="orderInformation.billingInfo.address.city">{{orderInformation.billingInfo.address.city}} </span>
                            <span *ngIf="!orderInformation.billingInfo.address.city"> {{'customer-service.NA' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right"  *ngIf="!orderInformation.billingInfo.address">
                            <span>  {{'customer-service.NA' |translate}}</span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-5 col-md-5">
                            <span *ngIf="shippingAddressInfoConfig && shippingAddressInfoConfig.displayStateCode">{{'customer-service.State/Zipcode' |translate}}</span>
                            <span *ngIf="shippingAddressInfoConfig && !shippingAddressInfoConfig.displayStateCode">{{'customer-service.Zipcode' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.address">
                            <span *ngIf="orderInformation.billingInfo.address.state || orderInformation.billingInfo.address.zipCode">   <span *ngIf="shippingAddressInfoConfig && shippingAddressInfoConfig.displayStateCode">{{orderInformation.billingInfo.address.state}}</span> {{orderInformation.billingInfo.address.zipCode}}</span>
                            <span *ngIf="!orderInformation.billingInfo.address.state && !orderInformation.billingInfo.address.zipCode"> {{'customer-service.NA' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right"  *ngIf="!orderInformation.billingInfo.address">
                            <span>  {{'customer-service.NA' |translate}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-5 col-md-5">
                            <span>{{'customer-service.Country' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.address">
                            <span *ngIf="orderInformation.billingInfo.address.country">{{orderInformation.billingInfo.address.country |uppercase}}</span>
                            <span *ngIf=" !orderInformation.billingInfo.address.country"> {{'customer-service.NA' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right"  *ngIf="!orderInformation.billingInfo.address">
                            <span>  {{'customer-service.NA' |translate}}</span>
                        </div>
                    </div>
                </div>
                <div class="column-equal" style="margin-left: auto; border: 1px solid #0f7bb6; padding:15px">
                    <div class="row">
                        <div class="col-md-12 text-right">
                            <span class="color-blue">{{'customer-service.PAY BY' |translate}}</span>
                        </div>
                    </div>

                    <div class="row" *ngIf="!isTitan">
                        <div class="col-sm-5 col-md-5">
                            <span>{{'order.Payment Method' |translate}}</span>
                        </div>
                        <!-- <div class="col-md-7 text-right" *ngIf="!orderInformation.billingInfo.paymentMethod">
                            <span >{{'customer-service.NA' |translate}}</span>
                        </div> -->
                        <div class="col-sm-7 col-md-7 text-right">
                            <span *ngIf="getImagePath(orderInformation.billingInfo.cardType)">{{paymentMethodTypeConstants.Credit_Card}}</span>
                            <span *ngIf="!getImagePath(orderInformation.billingInfo.cardType)">{{orderInformation.billingInfo.cardType}}</span>
                        </div>
                    </div>
                    <div class="row" *ngIf="orderInformation.billingInfo.cardType && !isTitan && getImagePath(orderInformation.billingInfo.cardType)">
                        <div class="col-sm-5 col-md-5">
                            <span>{{'customer-service.Card Type' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="getImagePath(orderInformation.billingInfo.cardType)">
                            <img [src]="getImagePath(orderInformation.billingInfo.cardType)" width="25%">
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="!getImagePath(orderInformation.billingInfo.cardType)">
                            <span>{{orderInformation.billingInfo.cardType}} </span>
                        </div>
                    </div>
                    <div class="row" *ngIf="paymentType.eCheck==orderInformation.billingInfo.paymentMethod">
                        <div class="col-sm-5 col-md-5">
                            <span>{{'order.Bank Name' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.bankName">
                            <span >{{'customer-service.NA' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.bankName">

                                    <span >{{orderInformation.billingInfo.bankName}}</span>
                            </div>
                    </div>
                    <div class="row" *ngIf="paymentType.eCheck==orderInformation.billingInfo.paymentMethod">
                        <div class="col-sm-5 col-md-5">
                            <span>{{'order.Accountholder' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.nameOnBankAccount">
                            <span >{{'customer-service.NA' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.nameOnBankAccount">

                                    <span >{{orderInformation.billingInfo.nameOnBankAccount}}</span>
                            </div>
                    </div>
                    <div class="row" *ngIf="paymentType.eCheck==orderInformation.billingInfo.paymentMethod">
                        <div class="col-sm-5 col-md-5">
                            <span>{{'order.Account Number' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.accountNumber">
                            <span >{{'customer-service.NA' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.accountNumber">

                                    <span>Ending with {{orderInformation.billingInfo.accountNumber.substr(orderInformation.billingInfo.accountNumber.length - 4)}}</span>
                            </div>
                    </div>
                    <div class="row" *ngIf="paymentType.eCheck==orderInformation.billingInfo.paymentMethod">
                        <div class="col-sm-5 col-md-5">
                            <span>{{'order.Email' |translate | translateKey}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.email">
                            <span >{{'customer-service.NA' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.email">

                                    <span>{{orderInformation.billingInfo.email}}</span>
                            </div>
                    </div>
                    <div class="row" *ngIf="paymentType.eCheck==orderInformation.billingInfo.paymentMethod">
                        <div class="col-sm-5 col-md-5">
                            <span>{{'order.Phone Number' |translate | translateKey}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.phone">
                            <span >{{'customer-service.NA' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.phone">
                            <span>{{orderInformation.billingInfo.phone}}</span>
                        </div>
                    </div>
                    <div class="row" *ngIf="paymentType.eCheck==orderInformation.billingInfo.paymentMethod">
                        <div class="col-sm-5 col-md-5">
                            <span>{{'order.Account Type' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.accountType">
                            <span>{{'customer-service.NA' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.accountType">
                            <span *ngIf="orderInformation.billingInfo.accountType === AccountTypeConstants.Savings">{{accountTypeEnums.Savings}}</span>
                            <span *ngIf="orderInformation.billingInfo.accountType === AccountTypeConstants.Checking">{{accountTypeEnums.Checking}}</span>
                        </div>
                    </div>
                    <div class="row" *ngIf="isTitan">
                        <div class="col-sm-5 col-md-5">
                            <span>{{'order.Payment Method' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.paymentMethod">
                            <span >{{'customer-service.NA' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.paymentMethod">
                            <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Credit_Card">{{paymentMethodTypeConstants.Credit_Card}}</span>
                            <!-- <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.eCheck">{{paymentMethodTypeConstants.eCheck}}</span> -->
                            <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Money_order">{{paymentMethodTypeConstants.Money_Order}}</span>
                            <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.PayPal">{{paymentMethodTypeConstants.Paypal}}</span>
                            <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Cash">{{paymentMethodTypeConstants.Cash}}</span>
                            <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.eCheck">{{paymentMethodTypeConstants.eCheck}}</span>
                        </div>
                    </div>
                    <div class="row" *ngIf="paymentType.Credit_Card==orderInformation.billingInfo.paymentMethod && isTitan">
                        <div class="col-sm-5 col-md-5">
                            <span>{{'order.Cardholder' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.cardHolderName">
                            <span>{{'customer-service.NA' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.cardHolderName">

                            <span>{{orderInformation.billingInfo.cardHolderName}}</span>
                        </div>
                    </div>
                    <div class="row" *ngIf="paymentType.Credit_Card==orderInformation.billingInfo.paymentMethod && isTitan">
                        <div class="col-sm-5 col-md-5">
                            <span>{{'customer-service.Card Type' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.cardType">
                            <span>{{'customer-service.NA' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.cardType">
                            <img [src]="getImagePath(orderInformation.billingInfo.cardType)" width="25%">
                        </div>
                    </div>
                    <div class="row" *ngIf="paymentType.Credit_Card==orderInformation.billingInfo.paymentMethod && isTitan">
                        <div class="col-sm-5 col-md-5">
                            <span>{{'customer-service.Card Number' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right">
                            <span *ngIf="!orderInformation.billingInfo.maskedCard">NA</span>
                            <span *ngIf="orderInformation.billingInfo.maskedCard">Ending in {{orderInformation.billingInfo.maskedCard | slice:-4}}</span>
                        </div>
                    </div>
                    <div class="row" *ngIf="paymentType.Credit_Card==orderInformation.billingInfo.paymentMethod && isTitan">
                        <div class="col-sm-5 col-md-5">
                            <span>{{'order.Expiration' |translate}}</span>
                        </div>
                        <div class="col-sm-7 col-md-7 text-right">
                                <span *ngIf="!orderInformation.billingInfo.expiryMonth">{{'customer-service.NA' |translate}}</span>
                            <span *ngIf="orderInformation.billingInfo.expiryMonth"><span *ngIf="orderInformation.billingInfo.expiryMonth.length === 1">0</span>{{orderInformation.billingInfo.expiryMonth}} / {{orderInformation.billingInfo.expiryYear.substring(2,4)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row clearfix"></div>
        <div class="table-responsive mb-20 print-hide">
            <table class="table table-striped custab">
                <thead>
                    <tr>
                        <th>{{'customer-service.Name' |translate}}</th>
                        <th>{{'customer-service.Date' |translate}}</th>
                        <th>{{'customer-service.Time' |translate}}</th>
                        <th>{{'customer-service.Notes' |translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let note of orderNotes">
                        <td>{{note.name}}</td>
                        <td>{{note.dateFormat}}</td>
                        <td>{{note.hoursFormat}}</td>
                        <td id="notes-content" class="textarea-format">{{note.note}}</td>
                    </tr>
                    <tr *ngIf="orderNotes && orderNotes.length===0">
                        <td colspan="4" class="text-center">{{'ticketing-system.No records found' |translate | translateKey}}</td>

                     </tr>
                </tbody>
            </table>
        </div>

        <div class="row clearfix"></div>
        <div class="print-hide">
            <div class="table-responsive">
                <table class="table table-striped custab">
                    <thead>
                        <tr>
                            <th class="width-125 pointer" tabindex="0" (keyup.enter)="sortTicketsByColumn('TICKET_NUMBER')" (click)="sortTicketsByColumn('TICKET_NUMBER')">{{'ticketing-system.Ticket #' |translate}}&nbsp;
                                <i class="fa fa-sort" [ngClass]="{'fa-sort': ticketsSortColumn != 'TICKET_NUMBER', 'fa-sort-asc': (ticketsSortColumn  == 'TICKET_NUMBER' && !ticketsIsDesc), 'fa-sort-desc': (ticketsSortColumn  == 'TICKET_NUMBER' && ticketsIsDesc) }"
                                    style="font-size:12px"></i>
                            </th>
                            <th>{{'ticketing-system.Subject' |translate}}</th>
                            <th class="width-250 pointer" tabindex="0" (keyup.enter)="sortTicketsByColumn('SUBTYPE')" (click)="sortTicketsByColumn('SUBTYPE')">{{'ticketing-system.Ticket Subtype' |translate}} &nbsp;
                                <i class="fa fa-sort" [ngClass]="{'fa-sort': ticketsSortColumn != 'SUBTYPE', 'fa-sort-asc': (ticketsSortColumn  == 'SUBTYPE' && !ticketsIsDesc), 'fa-sort-desc': (ticketsSortColumn  == 'SUBTYPE' && ticketsIsDesc) }"
                                    style="font-size:12px"></i>
                            </th>
                            <th class="width-100 pointer" tabindex="0" (keyup.enter)="sortTicketsByColumn('DUE_DATE')" (click)="sortTicketsByColumn('DUE_DATE')">{{'ticketing-system.Due Date' |translate}}&nbsp;
                                <i class="fa fa-sort" [ngClass]="{'fa-sort': ticketsSortColumn != 'DUE_DATE', 'fa-sort-asc': (ticketsSortColumn  == 'DUE_DATE' && !ticketsIsDesc), 'fa-sort-desc': (ticketsSortColumn  == 'DUE_DATE' && ticketsIsDesc) }"
                                    style="font-size:12px"></i>
                            </th>
                            <th class="width-40 pointer" tabindex="0" (keyup.enter)="sortTicketsByColumn('CREATED_DATE')" (click)="sortTicketsByColumn('CREATED_DATE')">{{'ticketing-system.Created Date' |translate}}&nbsp;
                                <i class="fa fa-sort" [ngClass]="{'fa-sort': ticketsSortColumn != 'CREATED_DATE', 'fa-sort-asc': (ticketsSortColumn  == 'CREATED_DATE' && !ticketsIsDesc), 'fa-sort-desc': (ticketsSortColumn  == 'CREATED_DATE' && ticketsIsDesc) }"
                                    style="font-size:12px"></i>
                            </th>
                            <th class="width-175 pointer" tabindex="0" (keyup.enter)="sortTicketsByColumn('UPDATED_DATE')" (click)="sortTicketsByColumn('UPDATED_DATE')">{{'ticketing-system.Last Modified Date' |translate}}&nbsp;
                                <i class="fa fa-sort" [ngClass]="{'fa-sort': ticketsSortColumn != 'UPDATED_DATE', 'fa-sort-asc': (ticketsSortColumn  == 'UPDATED_DATE' && !ticketsIsDesc), 'fa-sort-desc': (ticketsSortColumn  == 'UPDATED_DATE' && ticketsIsDesc) }"
                                    style="font-size:12px"></i>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let ticket of tickets| paginate: { itemsPerPage: ticketsPageSize, currentPage: ticketsPageNumber, totalItems: ticketsPageCount }">
                            <td *ngIf="isTicketView">
                                <a tabindex="0" (keyup.enter)="goToViewTicket(ticket.id,ticket.ticketNumber)" (click)="goToViewTicket(ticket.id,ticket.ticketNumber)">{{ticket.ticketNumber}}</a>
                            </td>
                            <td *ngIf="!isTicketView">{{ticket.ticketNumber}}</td>
                            <td>{{ticket.subject}} </td>
                            <td>{{ticket.subType}}</td>
                            <td>{{ticket.dueDate | date: 'dd-MMM-yyyy'}}</td>
                            <td>{{ticket.createdDate | date: 'dd-MMM-yyyy'}}</td>
                            <td>{{ticket.modifiedDate | date: 'dd-MMM-yyyy'}}</td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="tickets.length === 0">
                        <tr>
                           <td colspan="6" class="text-center">{{'ticketing-system.No records found' |translate | translateKey}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- <span class="absolute-position" *ngIf="tickets.length > 0">
                <span>{{ticketsPageCount}} {{'store.record(s) found' |translate | translateKey}}</span>
            </span> -->
            <pagination-controls (pageChange)="ticketsPageChange($event)" class="pull-right"></pagination-controls>
        </div>
        <div class="row clearfix"></div>
        <div class="table-responsive mb-20 print-hide">
            <table class="table table-striped custab">
                <thead>
                    <tr>
                        <th class="width-150">{{'customer-service.Username' |translate}}</th>
                        <th class="width-100">{{'customer-service.Date' |translate}}</th>
                        <th class="width-100">{{'customer-service.Time' |translate}}</th>
                       <th>{{'customer-service.Log' |translate}}</th>
                    </tr>
                </thead>
                <tbody>
                     <tr *ngFor="let log of orderLogs">
                        <td>{{log.userName}}</td>
                        <td>{{log.dateFormat }}</td>
                        <td>{{log.hoursFormat}}</td>
                        <td>{{log.message}}</td>
                    </tr>
                    <tr *ngIf="orderLogs.length===0">
                        <td colspan="4" class="text-center">{{'ticketing-system.No records found' |translate | translateKey}}</td>

                     </tr>
                </tbody>

            </table>
        </div>
    </div>
</section>



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/order-view.component.html